module.exports = __webpack_public_path__ + "static/media/bmp-icon.981f4c08.svg";